import { useTheme } from "@catchoftheday/theme";

import { minusOnePx as minusOnePxFunc } from "../minusOnePx";

import { useMedia } from "./useMedia";

type UseBreakpointProps = {
  minusOnePx?: boolean;
};

export const useBreakpoint = ({
  minusOnePx = false,
}: UseBreakpointProps = {}): {
  isMobile: boolean;
  isDesktop: boolean;
} => {
  const { breakpoints } = useTheme();
  const mobileBp = minusOnePx
    ? minusOnePxFunc(breakpoints.md, true)
    : breakpoints.md;
  const desktopBp = minusOnePx
    ? minusOnePxFunc(breakpoints.lg, true)
    : breakpoints.lg;
  const isMobile = !!useMedia<boolean>([`(max-width: ${mobileBp})`], [true]);
  const isDesktop = !!useMedia<boolean>([`(max-width: ${desktopBp})`], [true]);
  return {
    isMobile,
    isDesktop,
  };
};
